import api from '@/api'
import _ from 'lodash'

export default {
  async getRev(context, { organizationId, revId }) {
    const response = await api.quickaction.getById(organizationId, revId)

    context.commit('SET_REV', response.data)
    return response.data
  },

  getTags(context, rev) {
    const { organization, site } = rev.location
    return api.tag
      .getAll(organization._id, { filters: { sites: [site._id] } })
      .then(response => response.data.results)
  },

  async getRevChallenge(context, { organizationId, revId }) {
    const challengeResponse = await api.challenge.getChallengesFromRev(
      'quick-actions',
      organizationId,
      revId
    )
    const challenge = await (challengeResponse.data?.[0] ?? null)
    context.commit('SET_CHALLENGE', {
      challenge: {
        name: challenge?.name ?? '',
      },
    })

    return challenge
  },

  async translateRev(
    context,
    { organizationId, revId, targetLanguage, fieldsToTranslate }
  ) {
    const { data: rev } = await api.quickaction.getById(organizationId, revId)

    const translatedRev = Object.assign({}, rev)

    for (const field of fieldsToTranslate) {
      if (!_.get(rev, field)) continue
      const translatedField = await api.translate.text(
        organizationId,
        _.get(rev, field),
        targetLanguage
      )
      _.set(translatedRev, field, translatedField.data.translatedText)
    }

    context.commit('SET_REV', translatedRev)

    return translatedRev
  },
}
